import React from "react";
import Search from "./Search";

import "./App.css";

export default function App() {
  return (
    <div className="App container weather-app">
      <Search />
    </div>
  );
}
